import { render, staticRenderFns } from "./DeleteServers.vue?vue&type=template&id=03ba9945&"
import script from "./DeleteServers.vue?vue&type=script&lang=js&"
export * from "./DeleteServers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports